module.exports = __webpack_public_path__ + "static/media/01.939c5eff.png";